// The widget ships English only.
//
// This file previously imported all 57 locale JSONs and handed them to
// createI18n, so every visitor to a customer site downloaded ~291 KB of
// translations (a 334 KB chunk, 100 KB gzip) in order to render one language.
// It was the single largest item in the widget bundle.
//
// The other locale files are deliberately left on disk rather than deleted:
// upstream updates them most releases, so deleting them would produce
// conflicts on every merge, and re-enabling a language is a one-line import.
//
// To ship another language, import it here and add it to the export. Anything
// not listed falls back to English via `fallbackLocale` in
// app/javascript/entrypoints/widget.js.
import en from './locale/en.json';

export default {
  en,
};
